/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBike48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M17.804 9v29h3.446'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M17.554 35.5h-6.5 6.5z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M10 3.5l1.662-.73a2.062 2.062 0 012.893 1.888v.982A3.36 3.36 0 0017.915 9h.14M30.305 9v29H27'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M30.554 35.5h6.5-6.5z'
      />
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M35.109 29.5h-4.125V32h4.125v-2.5zm-22.11 0h4.126V32H13v-2.5zm.5-14.5c.57 1.846.792 3.012 4.305 3l-.125 4.5c-2.705.106-5.474-1.705-6.125-4L13.5 15zm21.11 0c-.57 1.846-.791 3.012-4.305 3l.125 4.5c2.705.106 5.474-1.705 6.125-4L34.61 15z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M38.109 3.5l-1.663-.73a2.062 2.062 0 00-2.892 1.888v.982A3.36 3.36 0 0130.194 9h-.14'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M21.25 25.842c.95-.575 1.884-.853 2.805-.855.92.002 1.854.28 2.804.855v17.854a2.803 2.803 0 01-2.804 2.804h-.001a2.803 2.803 0 01-2.804-2.804V25.842z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M30.555 25.5h3.597a.9.9 0 01.902.902v4.696a.9.9 0 01-.902.902h-3.598v-6.5zm-13 0h-3.598a.902.902 0 00-.902.902v4.696a.902.902 0 00.902.902h3.598v-6.5zm3.695.342v-3.538a2.803 2.803 0 012.804-2.804h.001a2.804 2.804 0 012.804 2.804v3.538c-.95-.575-1.885-.853-2.805-.855-.92.002-1.854.28-2.804.855zM17.555 11.5c-1.55 0-2.984.819-3.772 2.152l-1.159 1.96a4.566 4.566 0 003.93 6.888h1v-11zm13 0a4.38 4.38 0 013.771 2.152l1.158 1.96a4.565 4.565 0 01-3.93 6.888h-1v-11zm-6.5-8c-3.312 0-6 2.465-6 5.5 0 3.036 2.688 5.5 6 5.5 3.311 0 5.5-2.464 5.5-5.5 0-3.035-2.189-5.5-5.5-5.5zM39.252 2l6.857 3.04-1.095 2.468a.8.8 0 01-1.055.407l-6.125-2.716L39.252 2zM8.856 2L2 5.04l1.094 2.468a.8.8 0 001.055.407l6.126-2.716L8.857 2z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20.787 9.088c1.047-1.07 2.186-1.243 3.268-1.243 1.081 0 2.22.173 3.268 1.243'
      />
    </svg>
  );
}

export default SvgBike48;
